import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';
import { useNavigate } from 'react-router-dom';

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { FaPencilRuler } from "react-icons/fa";
import { FaRegChartBar } from "react-icons/fa";
import { FaRegBuilding } from "react-icons/fa";
import { FaRegObjectGroup } from "react-icons/fa";
import { MdConveyorBelt } from "react-icons/md";
import { TbSum } from "react-icons/tb";
import { useSelector } from 'react-redux';

// 아이콘 및 메뉴 이름 데이터
const menuItems = [
    {
        id: 1,
        icon: <FaRegObjectGroup />,
        name: 'Project Overview',
        link: 'overview',
    },
    {
        id: 2,
        icon: <MdConveyorBelt />,
        name: 'Conveyors',
        link: 'conveyors',
    },
    {
        id: 3,
        icon: <TbSum />,
        name: 'Components',
        link: 'component',
        sub: true,
    },
    {
        id: 4,
        icon: <TbSum />,
        name: 'Pulleys',
        link: 'pulley',
        sub: true,
    },
    {
        id: 5,
        icon: <TbSum />,
        name: 'Structure',
        link: 'structure',
        sub: true,
    },
    {
        id: 6,
        icon: <FaRegBuilding />,
        name: 'Transfer Towers',
        link: 'towers',
    },
    {
        id: 7,
        icon: <FaPencilRuler />,
        name: 'Accessories',
        link: 'accessories',
    },
    {
        id: 8,
        icon: <FaRegChartBar />,
        name: 'Statistics',
        link: 'statistics',
    },
    // 이하 반복...
];

// 사이드 메뉴 컴포넌트
const SideMenu = () => {
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (loading || !project) {  // 이 부분이 없으면 'localStorage is not working' 에러가 떴다가 사라짐. 작동은 함. '24.1/10
    //         return;
    //     }
    //     setProjectId(JSON.parse(localStorage.getItem('project'))._id);
    // }, [loading, project]);

    // const { project } = useSelector(({ project }) => ({
    //     project: project.project
    // }))

    const project = useSelector(state => state.project.project);

    const onClickLink = (item) => {
        // const projectId = JSON.parse(localStorage.getItem('project'))._id;
        const projectId = project?._id;
        navigate(`/projects/${projectId}/${item.link}`);
    }

    return (
        <SideMenuBlock>
            <MenuList>
                {menuItems.map((item, index) => (
                    <MenuItem key={index} onClick={() => onClickLink(item)} isSub={!!item.sub}>
                        {/* <Link to={`/projects/${projectId}/${item.link}`}> */}
                        {/* <Link > */}
                            <MenuHeader>
                                {/* <Icon src={item.icon} alt="Menu Icon" /> */}
                                <Icon>{item.icon}</Icon>
                                <MenuName>{item.name}</MenuName>
                            </MenuHeader>
                        {/* </Link> */}
                    </MenuItem>
                ))}
            </MenuList>
            <StyledButton to="/projects">Project List</StyledButton>
        </SideMenuBlock>
    );
};

// 스타일드 컴포넌트를 사용하여 스타일을 정의합니다.
const SideMenuBlock = styled.div`
    // margin-top: 1rem;
    width: 14rem;
    min-width: 14rem;   // 이것을 주지 않으면 오른쪽 폭이 늘어날 때 줄어들어 버림. 
    border-right: 1px solid ${palette.gray[3]};
    height: 92vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // Sticky로 변경. '24.2/27
    position: sticky;
    left: 0;
    top: 5rem;

    // 뷰포트
    @media (max-width: 980px) {
        width: 5rem;
        min-width: 5rem;
        // transition: 0.5s;
    }
`;

const MenuList = styled.ul`
    display: flex;
    flex-direction: column;
    
`;

const MenuItem = styled.li`
    padding-left: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    &:hover {
        background-color: ${palette.gray[2]};
        cursor: pointer;
        transition: 0.3s;
    }
    ${(props) => props.isSub && css`
        padding-left: 2rem;
    `}
`;

const MenuHeader = styled.div`
    display: flex;
    align-items: center;
`;

const Icon = styled.div`
    display: flex;
    align-items: center;
    // width: 24px;
    // height: 24px;
    
    color: ${palette.yachtBlue};
    font-size: 1.25rem;
    margin-right: 0.5rem;

`;

const MenuName = styled.span`
    font-size: 1rem;
    font-weight: 500;
    @media (max-width: 980px) {
        display: none;
    }
`;

const StyledButton = styled(Link)`
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    padding-top: 0.5rem;
    padding-bottom: 0.8rem;
    background-color: ${palette.yachtBlue};
    color: white;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.yachtBlue};
        border: 1px solid ${palette.yachtBlue};
        transition: 0.3s;
    }

    // 뷰포트
    @media (max-width: 980px) {
        display: none;
    }
`;

export default SideMenu;
